import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= "/log ingestor.jpeg"
              isBlog={false}
              title="Log ingestor and Query Interface"
              description="Effortlessly collect, analyze, and gain insights from logs with our streamlined Log Ingestor and Query Interface built using Reactjs, fastAPI and Tidb Mysql database."
              ghLink="https://github.com/AishaAgarwal/Log-ingestor-and-query-interface"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= "/CP.jpeg"
              isBlog={false}
              title="Community detection using Graph Algorithm"
              description="Defining reddit's communitinities for various social causes using graph algorithms."
              ghLink="https://github.com/AishaAgarwal/CP_final"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= "ToDoApplication.jpeg"
              isBlog={false}
              title="To-Do-List Application"
              description="simple yet effective To-Do List Application built with HTML, CSS, and JavaScript. It allows you to manage your tasks and stay organized. You can add, edit, mark as completed, and delete tasks effortlessly."
              ghLink="https://github.com/AishaAgarwal/To-Do-List-Application/tree/main"
              demoLink="https://simply-tasked-list.netlify.app/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= "/Isvara.jpg"
              isBlog={false}
              title="Isvara"
              description="An AI-based software solution for constant eye strain from prolonged screen time, Providing devs eye protection and care via real-time notification"
              ghLink="https://github.com/AishaAgarwal/Isvara-Frontend"
              demoLink="https://isvaraf.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath="/finance.jpeg"
              isBlog={false}
              title="Personal Finance Tracker"
              description="The Personal Finance Tracker is a web application that helps you track your income, expenses, and financial goals. It provides an interface to add transactions, set financial goals, and receive bill reminders."
              ghLink="https://github.com/AishaAgarwal/Personal-Finance-Tracker"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath= "/Careerocity.jpeg"
              isBlog={false}
              title="Careerocity"
              description="A web application to help students in finding out the proper career path by recommending them based on their skills and interests along with providing them the required resources."
              ghLink="https://github.com/AishaAgarwal/FlaskServer_Careerocity"
              // demoLink="https://blogs.soumya-jit.tech/"      <--------Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
